export const containers = {
  CONSULTANT: 'CONSULTANT',
  SSO: 'SSO',
};
